/* @flow */

import React from 'react';

import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';

import IntlMessageComponent from 'components/formatters/intlMessage';
import IconCancel from 'components/icons/cancel';

type MessageDialogComponentProps = {
  open: boolean;
  text: string;
  title?: string;
  maxWidth?: string;
  disableBackdropClick?: boolean;
  disableEscapeKeyDown?: boolean;
  onClose: () => void;
}

export default function MessageDialogComponent(props: MessageDialogComponentProps) {
  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      fullWidth
      maxWidth={props.maxWidth || "sm"}
      disableBackdropClick={props.disableBackdropClick}
      disableEscapeKeyDown={props.disableEscapeKeyDown}
    >
      <DialogTitle disableTypography>
        <Box display="flex" alignItems="center">
          <Box flexGrow={1}>
            {props.title &&
              <Typography variant="h6">
                <IntlMessageComponent id={props.title} />
              </Typography>
            }
          </Box>

          <IconButton aria-label="close" onClick={props.onClose}>
            <IconCancel fontSize="small" />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1">
          <IntlMessageComponent id={props.text} />
        </Typography>
      </DialogContent>
    </Dialog>
  );
}